// extracted by mini-css-extract-plugin
export var fileUpload = "_f1-1";
export var modalButton = "_f1-0";